import { render } from "./MigrationV5WaitStep.vue?vue&type=template&id=62c6f568&scoped=true"
import script from "./MigrationV5WaitStep.vue?vue&type=script&lang=ts"
export * from "./MigrationV5WaitStep.vue?vue&type=script&lang=ts"

import "./MigrationV5WaitStep.vue?vue&type=style&index=0&id=62c6f568&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62c6f568"

export default script